import {ContactType} from "../../../libs/enum/contact-type";

export class StatisticTopReceiptContactDto {

  public contactId: string | undefined; // UUID
  public contactType: ContactType | undefined;
  public contactNumber: string | undefined;
  public contactFullName: string | undefined;
  public currencyCode!: string; // Enum: AccCurrency
  public receiptCount!: number;
  public sumTotalNetAmount!: number;
  public minTotalNetAmount!: number;
  public maxTotalNetAmount!: number;
  public avgTotalNetAmount!: number;

  constructor(init?: Partial<StatisticTopReceiptContactDto> | undefined) {
    Object.assign(this, init);
  }
}
